import {
    SetupDataStore,
    WorkflowStage,
    WorkflowStore,
    useProviderConfig,
} from '@servicetitan/financing-workflow-shared';
import { useTechnicianContactValidation } from '@servicetitan/financing-application-shared';
import { useEffect, useState } from 'react';
import { WorkflowRenderer as ApplicationWorkflowRenderer } from '@servicetitan/financing-application-workflow-shared';
import { WorkflowRenderer as PrequalsWorkflowRenderer } from '@servicetitan/financing-prequalification-workflow-shared';
import { Container as LoanBannerContainer } from '../loan-banner/Container';
import { CustomerDataLoadingStore } from '../../CustomerDataLoadingStore';
import { LoadingScreen } from '@servicetitan/financing-utils-shared';

const customerDataRequiredStages: WorkflowStage[] = [
    'application',
    'application-with-co-application',
];

export const Container = () => {
    const { workflowStage, setWorkflowStage } = WorkflowStore.useStore();
    const { defaultWorkflowStage } = useProviderConfig();
    const { setupData } = SetupDataStore.useStore();
    const { isCustomerDataLoading } = CustomerDataLoadingStore.useStore();

    useTechnicianContactValidation();
    const provider = setupData?.provider;
    const [prevProvider, setPrevProvider] = useState<string | null>(null);

    useEffect(() => {
        if (workflowStage == null && !setupData?.isInSecondLook) {
            setWorkflowStage(defaultWorkflowStage);
        }
    }, [workflowStage, defaultWorkflowStage, setWorkflowStage, setupData?.isInSecondLook]);

    useEffect(() => {
        // If the user has switched providers, we may need to reset the workflow stage.
        if (prevProvider !== provider) {
            setPrevProvider(provider ?? null);
            if (
                workflowStage != null &&
                workflowStage !== defaultWorkflowStage &&
                !setupData?.isInSecondLook
            ) {
                setWorkflowStage(defaultWorkflowStage);
            }
        }
    }, [
        provider,
        prevProvider,
        setPrevProvider,
        defaultWorkflowStage,
        setWorkflowStage,
        workflowStage,
        setupData?.isInSecondLook,
    ]);

    const activeStage = workflowStage ?? defaultWorkflowStage;
    const needsCustomerData = customerDataRequiredStages.includes(activeStage);

    return (
        <div style={{ width: '100%' }}>
            <LoanBannerContainer />
            {needsCustomerData && isCustomerDataLoading ? (
                <LoadingScreen message="Loading..." />
            ) : setupData?.prequalificationId ? (
                <PrequalsWorkflowRenderer workflowStage={activeStage} />
            ) : (
                <ApplicationWorkflowRenderer workflowStage={activeStage} canChangeProvider />
            )}
        </div>
    );
};
